/********************************************************************
 * Project: WDCK（2021）
 * Class: InfoHTRsv
 * ----------------------------------------
 * <summary>
 * InfoHTRsv
 * </summary>
 * <history>
 *      ThaiTV     2022/01/05      Create
 * </history>
 ********************************************************************/
export class InfoHTRsvDTO {
    InsurerNum: string ;
    InsuranceCardSign: string ;
    InsuranceCardNum: string ;
    InsuranceCardBranchNum: string ;
    PersonFamilyDiv: string ;
    CoCode: string ;
    constructor(){
        this.InsurerNum = "";
        this.InsuranceCardSign = "";
        this.InsuranceCardNum = "";
        this.InsuranceCardBranchNum = "";
        this.PersonFamilyDiv = "";
        this.CoCode = "";
    }
}
